import type { LiteralObject } from "@/types";

import findIndex from "lodash/findIndex";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { buildSeverityGroup } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/gridUtils";
import { useReferentialMaterials } from "@/entities/referential/referential-materials";
import { getModelLink } from "@/modules/model";

export const useSeveritySection = () => {
  const { t } = useTranslation();
  const { materials, isSuccess, isLoading } = useReferentialMaterials();
  const { pathname } = useLocation();
  const firstElementSamples = isSuccess
    ? materials.slice(0, 3).map(({ name }) => name)
    : [];
  const materialValues = [
    ...firstElementSamples.map((name, index) => ({ id: `${index}`, name })),
    { id: "ellipsis", name: "…" },
  ];
  const severityGroupName = t("form:severityGrid.groupName");
  const [hasSeveritySection, setHasSeveritySection] = useState(false);
  const isTemplateInterventionPath = pathname?.startsWith(
    getModelLink("interventiontemplate")
  );

  const isDisabled = hasSeveritySection || !isSuccess;

  const updateSeveritySectionAvailability = (
    schema: LiteralObject & { groups: { legend: string }[] }
  ) => {
    if (!schema) {
      return;
    }

    const index = findIndex(
      schema.groups,
      ({ legend }) => legend === severityGroupName
    );
    setHasSeveritySection(index !== -1);
  };

  const buildGroup = useCallback(
    () => buildSeverityGroup(materialValues),
    [materialValues]
  );

  return {
    showAddSeveritySection: isTemplateInterventionPath,
    isDisabled,
    isLoading,
    updateSeveritySectionAvailability,
    buildSeverityGroup: buildGroup,
  };
};
